import { Box, Divider, Grid, Typography } from '@mui/material'
import { DataPanel } from '../../../components/DataPanel'
import MultistepFormField from '../../../components/MultistepForm/MultistepFormField'

const TreatingDentistStep = () => {
    return (
        <Box>
            <DataPanel
                title="Treating Dentist and Treatment Location Information"
                content={
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography>
                                I hereby certify that the procedures as indicated by date are in
                                progress (for procedures that require multiple visits) or have been
                                completed and that the fees submitted are the actual fees I have
                                charged and intend to collect for those procedures.
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Typography>Signed (Treating Dentist)</Typography>
                            <MultistepFormField name="treatingDentist-signature" />
                        </Grid>
                        <Grid item xs={4}>
                            <Typography>Date</Typography>
                            <MultistepFormField
                                name="treatingDentist-signatureDate"
                                type="date"
                                inputProps={{ disableFuture: true }}
                            />
                        </Grid>
                        <Grid item xs={4} />
                        <Grid item xs={12}>
                            <Divider />
                        </Grid>
                        <Grid item xs={4}>
                            <MultistepFormField
                                label="Provider ID"
                                name="treatingDentist-providerId"
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <MultistepFormField
                                label="License Number"
                                name="treatingDentist-licenseNumber"
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <MultistepFormField label="Address" name="treatingDentist-address" />
                        </Grid>
                        <Grid item xs={4}>
                            <MultistepFormField label="City" name="treatingDentist-city" />
                        </Grid>
                        <Grid item xs={4}>
                            <MultistepFormField label="State" name="treatingDentist-state" />
                        </Grid>
                        <Grid item xs={4}>
                            <MultistepFormField label="Zip Code" name="treatingDentist-zipCode" />
                        </Grid>
                        <Grid item xs={4}>
                            <MultistepFormField
                                label="Phone Number"
                                name="treatingDentist-phoneNumber"
                                type="phone"
                                inputProps={{ sx: { width: '100%' } }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <MultistepFormField
                                label="Treating Provider Specialty"
                                name="treatingDentist-specialty"
                            />
                        </Grid>
                    </Grid>
                }
            />
        </Box>
    )
}

export default TreatingDentistStep
